import React from "react";
import StackComponent from "../../components/Base/StackComponent";
import TypographyComponent from "../../components/Base/TypographyComponent";
import styled from "@emotion/styled";
import LinkComponent from "../../components/Base/LinkComponent";

const ListItem = styled("li")(({ theme }) => ({}));

const FooterURLs = ({
  title,
  urlsArr,
  isMediumScreen,
  isSmallScreen,
  isExtraSmallScreen,
}) => {
  return (
    <StackComponent
      direction="column"
      sx={{ width: isMediumScreen ? "100%" : "175px" }}
    >
      <TypographyComponent
        sx={{
          color: "rgba(37, 61, 50, 1)",
          mb: "28px",
          textAlign: isMediumScreen ? "center" : "left",
        }}
        variant="boldAmount"
        component="h3"
      >
        {title}
      </TypographyComponent>
      <StackComponent
        direction="column"
        component="ul"
        spacing="8px"
        sx={{ listStyleType: "none", padding: "0" }}
      >
        {urlsArr.map((eachUrl) => (
          <ListItem key={eachUrl.name}>
            <LinkComponent
              linkStyle={{ width: "100%", display: "block" }}
              to={eachUrl.to}
            >
              <TypographyComponent
                sx={{
                  color: "rgba(120, 132, 125, 1)",
                  textAlign: isMediumScreen ? "center" : "left",
                  width: "100%",
                  display: "block",
                }}
                variant="totalLabel"
              >
                {eachUrl.label}
              </TypographyComponent>
            </LinkComponent>
          </ListItem>
        ))}
      </StackComponent>
    </StackComponent>
  );
};

FooterURLs.defaultProps = {
  title: "Some title",
  urlsArr: [
    {
      to: "/home",
      name: "home",
      label: "Home",
    },
  ],
};

export default FooterURLs;
